function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#201D1A",
  d: "M21.6 4.443H12L10.308 2.7C9.852 2.249 9.24 2 8.604 2H2.4C1.08 2 0 3.069 0 4.375v14.25C0 19.931 1.08 21 2.4 21h19.2c1.32 0 2.4-1.069 2.4-2.375V6.75c0-1.306-1.08-2.307-2.4-2.307z",
  transform: "translate(-288 -744) translate(280 736) translate(8 8)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M6.82 14.01c.312.015.597-.184.694-.506l1.192-3.95.41-1.36.164 1.332.702 5.668c.045.362.325.634.66.64h.012c.33 0 .612-.26.669-.614l.892-5.677c.12.23.345.374.589.374h4.018c.374 0 .678-.331.678-.74 0-.407-.304-.738-.678-.738h-3.61l-.733-1.5c-.135-.279-.414-.436-.707-.384-.285.052-.511.294-.56.605l-.36 2.293-.12.753-.092-.742-.576-4.658c-.042-.34-.296-.605-.61-.636-.32-.032-.61.178-.707.506L7.256 9.62l-.18.593-.091-.581-.337-2.145c-.05-.319-.284-.565-.578-.608-.292-.049-.579.126-.706.418L4.602 9.07H3.179c-.375 0-.679.33-.679.739 0 .408.304.74.679.74h1.857c.263 0 .503-.166.614-.426l.028-.062.524 3.337c.051.335.307.588.617.613z",
  transform: "translate(-288 -744) translate(280 736) translate(8 8) translate(2 2)"
});

var SvgProjectFolder = function SvgProjectFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProjectFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/projectFolder.1de9a10e.svg";
export { ForwardRef as ReactComponent };